/* Casona Deco — carrito lateral con recomendaciones.
   Orden: comprados juntos (custom.comprados_juntos) > complementarias de Shopify > mismo ambiente (hab:) > relacionadas > respaldo.
   Salvo "comprados juntos", solo se sugieren productos que cuesten al menos PISO × el producto más caro del carrito. */
(function () {
  'use strict';
  var root = document.getElementById('cd-cart');
  if (!root || window.CDCart) return;

  var FREE = parseInt(root.dataset.freeShip, 10) || 0;
  var PISO = 0.5; // piso de precio: 50% del producto más caro del carrito
  var HAB = { 'sala': 'sala-de-estar', 'mesa-cocina': 'mesa-y-cocina', 'jardin': 'jardin-y-terraza', 'dormitorio': 'dormitorio', 'bano': 'bano', 'entrada': 'entrada' };
  var ROOT_URL = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  var fallback = [];
  try { fallback = JSON.parse(document.getElementById('cd-cart-fallback').textContent) || []; } catch (e) {}

  var $ = function (sel) { return root.querySelector(sel); };
  var els = {
    count: $('[data-cd-count]'), ship: $('[data-cd-ship]'), items: $('[data-cd-items]'),
    reach: $('[data-cd-reach]'), pairs: $('[data-cd-pairs]'), foot: $('[data-cd-foot]'),
    subtotal: $('[data-cd-subtotal]'), cuotas: $('[data-cd-cuotas]'), pickup: $('[data-cd-pickup]')
  };
  var cart = null;
  var recCache = {}, pairCache = {}, habCache = {};
  var busy = false;
  var lastFocus = null;

  function money(cents) { return '$' + Math.round((cents || 0) / 100).toLocaleString('en-US'); }
  function esc(s) { return String(s == null ? '' : s).replace(/[&<>"']/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' }[c]; }); }
  function img(url, w) {
    if (!url) return '';
    if (url.indexOf('//') === 0) url = 'https:' + url;
    return url + (url.indexOf('?') > -1 ? '&' : '?') + 'width=' + (w || 200);
  }

  /* ---------- API ---------- */
  var nativeFetch = window.fetch.bind(window);
  function getCart() { return nativeFetch(ROOT_URL + 'cart.js', { headers: { Accept: 'application/json' } }).then(function (r) { return r.json(); }); }
  function change(key, qty) {
    return nativeFetch(ROOT_URL + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ id: key, quantity: qty }) }).then(function (r) { return r.json(); });
  }
  function add(variantId, qty) {
    return nativeFetch(ROOT_URL + 'cart/add.js', { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' }, body: JSON.stringify({ items: [{ id: Number(variantId), quantity: qty || 1 }] }) })
      .then(function (r) { if (!r.ok) return r.json().then(function (e) { throw e; }); return r.json(); });
  }
  function getJSON(url) {
    return nativeFetch(url, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.text() : ''; })
      .then(function (t) { try { return JSON.parse(t); } catch (e) { return null; } })
      .catch(function () { return null; });
  }
  function recsFor(productId) {
    if (recCache[productId]) return recCache[productId];
    var base = ROOT_URL + 'recommendations/products.json?product_id=' + productId + '&limit=8&intent=';
    var get = function (intent) {
      return nativeFetch(base + intent).then(function (r) { return r.ok ? r.json() : { products: [] }; })
        .then(function (d) { return (d && d.products) || []; }).catch(function () { return []; });
    };
    recCache[productId] = get('complementary').then(function (comp) {
      return get('related').then(function (rel) { return { comp: comp, rel: rel }; });
    });
    return recCache[productId];
  }
  // Comprados juntos + ambiente (hab:) del producto, desde templates/product.cdpairs.liquid
  function pairsFor(handle) {
    if (!handle) return Promise.resolve({ hab: '', pairs: [] });
    if (!pairCache[handle]) {
      pairCache[handle] = getJSON(ROOT_URL + 'products/' + encodeURIComponent(handle) + '?view=cdpairs')
        .then(function (d) { return (d && Array.isArray(d.pairs)) ? d : { hab: (d && d.hab) || '', pairs: [] }; });
    }
    return pairCache[handle];
  }
  // Más vendidos del mismo ambiente, desde templates/collection.cdjson.liquid
  function habList(hab) {
    var h = HAB[hab];
    if (!h) return Promise.resolve([]);
    if (!habCache[h]) {
      habCache[h] = getJSON(ROOT_URL + 'collections/' + h + '?sort_by=best-selling&view=cdjson')
        .then(function (d) { return Array.isArray(d) ? d : []; });
    }
    return habCache[h];
  }

  /* ---------- Render ---------- */
  function renderShip(total) {
    if (!FREE) { els.ship.hidden = true; return; }
    var gap = FREE - total;
    var pct = Math.max(4, Math.min(100, Math.round(total / FREE * 100)));
    els.ship.hidden = false;
    if (gap > 0) {
      els.ship.className = 'cd-ship';
      els.ship.innerHTML = 'Te faltan <strong>' + money(gap) + '</strong> para tener <strong>envío gratis</strong> en Santiago<div class="cd-ship__bar"><i style="width:' + pct + '%"></i></div>';
    } else {
      els.ship.className = 'cd-ship cd-ship--ok';
      els.ship.innerHTML = '¡Tienes envío gratis en Santiago!<div class="cd-ship__bar"><i style="width:100%"></i></div>';
    }
  }

  function renderItems() {
    if (!cart.items.length) {
      els.items.innerHTML = '<div class="cd-empty"><p>Tu carrito está vacío</p><a class="cd-btn cd-btn--cta" href="' + esc(root.dataset.fallbackUrl || '/collections/all') + '">Ver lo más vendido</a></div>';
      return;
    }
    els.items.innerHTML = cart.items.map(function (it) {
      var variant = (it.variant_title && it.variant_title !== 'Default Title') ? '<div class="cd-item__var">' + esc(it.variant_title) + '</div>' : '';
      return '<div class="cd-item">' +
        '<a class="cd-item__img" href="' + esc(it.url) + '">' + (it.image ? '<img src="' + esc(img(it.image, 200)) + '" alt="" loading="lazy">' : '') + '</a>' +
        '<div class="cd-item__main">' +
          '<div class="cd-item__top"><a href="' + esc(it.url) + '">' + esc(it.product_title) + '</a><b>' + money(it.final_line_price) + '</b></div>' + variant +
          '<div class="cd-item__row">' +
            '<div class="cd-qty"><button type="button" data-cd-qty="' + esc(it.key) + '" data-q="' + (it.quantity - 1) + '" aria-label="Quitar uno">−</button><span>' + it.quantity + '</span><button type="button" data-cd-qty="' + esc(it.key) + '" data-q="' + (it.quantity + 1) + '" aria-label="Agregar uno">+</button></div>' +
            '<button type="button" class="cd-rm" data-cd-qty="' + esc(it.key) + '" data-q="0">Eliminar</button>' +
          '</div>' +
        '</div></div>';
    }).join('');
  }

  function addBtn(p, cls) {
    var v = (p.variants || []).filter(function (x) { return x.available !== false; })[0];
    var multi = p.multi || (p.variants && p.variants.length > 1);
    if (!v || multi) return '<a class="' + cls + '" href="' + esc(p.url) + '" style="display:flex;align-items:center;justify-content:center;text-decoration:none">Ver</a>';
    return '<button type="button" class="' + cls + '" data-cd-add="' + v.id + '">+ Agregar</button>';
  }
  function pct(p) { return p.compare_at_price > p.price ? '-' + Math.round((p.compare_at_price - p.price) / p.compare_at_price * 100) + '%' : ''; }

  function renderPairs(list, title) {
    if (!list.length) { els.pairs.innerHTML = ''; return; }
    els.pairs.innerHTML = '<div class="cd-recs"><h3 style="margin-bottom:12px">' + esc(title) + '</h3><div class="cd-carousel">' +
      list.map(function (p) {
        var off = pct(p);
        return '<div class="cd-mini"><a class="cd-mini__img" href="' + esc(p.url) + '"><img src="' + esc(img(p.featured_image, 300)) + '" alt="" loading="lazy">' + (off ? '<em>' + off + '</em>' : '') + '</a>' +
          '<a class="cd-mini__t" href="' + esc(p.url) + '">' + esc(p.title) + '</a><b>' + money(p.price) + '</b>' + addBtn(p, 'cd-add') + '</div>';
      }).join('') + '</div></div>';
  }

  function renderRecs() {
    var items = cart.items;
    var inCart = {};
    items.forEach(function (i) { inCart[i.product_id] = true; });
    var usable = function (p) { return p && !inCart[p.id] && p.available !== false; };
    els.reach.innerHTML = '';

    if (!items.length) {
      renderPairs(fallback.filter(usable).slice(0, 8), 'Lo más vendido esta semana');
      return Promise.resolve();
    }

    var seeds = [], handles = {}, top = 0;
    items.forEach(function (i) {
      if (seeds.indexOf(i.product_id) === -1) { seeds.push(i.product_id); handles[i.product_id] = i.handle; }
      if ((i.price || 0) > top) top = i.price || 0;
    });
    seeds = seeds.slice(0, 3);
    var floor = Math.round(top * PISO);
    var token = cart.token + ':' + cart.item_count + ':' + cart.total_price;
    renderRecs.token = token;

    return Promise.all([
      Promise.all(seeds.map(recsFor)),
      Promise.all(seeds.map(function (id) { return pairsFor(handles[id]); }))
    ]).then(function (res) {
      if (renderRecs.token !== token) return;
      var recs = res[0], data = res[1];
      var hab = '';
      data.forEach(function (d) { if (!hab && d && d.hab) hab = d.hab; });

      return habList(hab).then(function (habItems) {
        if (renderRecs.token !== token) return;
        var seen = {}, out = [];
        var push = function (p, useFloor) {
          if (out.length >= 8 || !usable(p) || seen[p.id]) return;
          if (useFloor && (p.price || 0) < floor) return;
          seen[p.id] = 1; out.push(p);
        };

        // 1. Comprados juntos (datos reales de pedidos, sin piso)
        data.forEach(function (d) { ((d && d.pairs) || []).forEach(function (p) { push(p, false); }); });
        var bought = out.length;
        // 2-5. Resto, respetando el piso de precio
        recs.forEach(function (r) { r.comp.forEach(function (p) { push(p, true); }); });
        habItems.forEach(function (p) { push(p, true); });
        recs.forEach(function (r) { r.rel.forEach(function (p) { push(p, true); }); });
        fallback.forEach(function (p) { push(p, true); });
        // Si quedan muy pocas, se relaja el piso con el mismo ambiente
        if (out.length < 4) {
          habItems.forEach(function (p) { push(p, false); });
          fallback.forEach(function (p) { push(p, false); });
        }

        var title = bought ? 'Otros clientes también compraron' : (hab && HAB[hab] ? 'Completa el ambiente' : 'Combina con tu pedido');
        renderPairs(out, title);
      });
    });
  }

  function render() {
    els.count.textContent = cart.item_count;
    renderShip(cart.total_price);
    renderItems();
    var empty = !cart.items.length;
    els.foot.hidden = empty;
    els.pickup.hidden = empty;
    els.ship.hidden = empty || !FREE;
    els.subtotal.textContent = money(cart.total_price);
    els.cuotas.textContent = 'o 6 cuotas de ' + money(Math.floor(cart.total_price / 6)) + ' sin interés · IVA incluido';
    updateBubbles();
    return renderRecs();
  }

  function updateBubbles() {
    document.querySelectorAll('.cart-link__bubble').forEach(function (b) {
      b.classList.toggle('cart-link__bubble--visible', cart.item_count > 0);
      var n = b.querySelector('.cart-link__bubble-num');
      if (n) n.textContent = cart.item_count;
    });
  }

  function refresh() {
    return getCart().then(function (c) { cart = c; return render(); });
  }

  /* ---------- Abrir / cerrar ---------- */
  function open() {
    lastFocus = document.activeElement;
    document.documentElement.classList.add('cd-cart-open');
    root.setAttribute('aria-hidden', 'false');
    setTimeout(function () { var x = root.querySelector('.cd-cart__x'); if (x) x.focus(); }, 50);
    return refresh();
  }
  function close() {
    document.documentElement.classList.remove('cd-cart-open');
    root.setAttribute('aria-hidden', 'true');
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }
  function isOpen() { return document.documentElement.classList.contains('cd-cart-open'); }

  /* ---------- Eventos ---------- */
  document.addEventListener('click', function (e) {
    var t = e.target;
    if (t.closest('[data-cd-close]')) { e.preventDefault(); close(); return; }

    var q = t.closest('[data-cd-qty]');
    if (q && root.contains(q)) {
      if (busy) return;
      busy = true; root.setAttribute('aria-busy', 'true');
      change(q.getAttribute('data-cd-qty'), parseInt(q.getAttribute('data-q'), 10))
        .then(function (c) { cart = c; return render(); })
        .finally(function () { busy = false; root.removeAttribute('aria-busy'); });
      return;
    }

    var a = t.closest('[data-cd-add]');
    if (a) {
      e.preventDefault();
      if (a.disabled) return;
      var label = a.textContent;
      a.disabled = true; a.textContent = 'Agregando…';
      add(a.getAttribute('data-cd-add'), 1)
        .then(function () { return open(); })
        .catch(function (err) { alert((err && (err.description || err.message)) || 'No pudimos agregar el producto.'); })
        .finally(function () { a.disabled = false; a.textContent = label; });
      return;
    }

    // Íconos/links del carrito → abrir el carrito lateral
    var link = t.closest('a[href]');
    if (link && !root.contains(link)) {
      var href = link.getAttribute('href') || '';
      if (/^(https?:\/\/[^/]+)?\/cart\/?(\?.*)?$/.test(href) || link.classList.contains('js-drawer-open-cart')) {
        e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
        open();
      }
    }
  }, true);

  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen()) close(); });

  // Cualquier "agregar al carrito" del tema (ficha, compra rápida, barra fija) abre este carrito
  window.fetch = function (input, init) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var p = nativeFetch(input, init);
    if (/\/cart\/add(\.js)?(\?|$)/.test(url)) {
      p.then(function (r) { if (r.ok) setTimeout(open, 50); }).catch(function () {});
    }
    return p;
  };

  window.CDCart = { open: open, close: close, refresh: refresh, add: add };
  getCart().then(function (c) { cart = c; updateBubbles(); });
})();
